import React, { ReactNodeArray } from 'react';
import Box from './Box';
import Flex, { IFlexBoxProps } from './Flex';

interface IStackProps extends IFlexBoxProps {
    space: number | number[];
    children: ReactNodeArray;
}

const Stack: React.FC<IStackProps> = (props) => {
    const { space, children, ...rest } = props;

    const flexProps: any = rest;

    return (
        <Flex {...flexProps} flexDirection="column">
            {
                props.children.map((cc, ii) => (
                    <Box key={ii} mt={ii === 0 ? undefined : space}>
                        {cc}
                    </Box>
                ))
            }
        </Flex>
    );
};

export default Stack;

Stack.defaultProps = {
    alignItems: 'left',
    justifyContent: 'flex-start'
};
